import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';
import ColumnChooser from '../../../../components/ColumnChooser';
import TableActions from '../../../../components/TableActions';
import { ColumnChooserModel } from '../../../../models/common/ColumnChooserModel';
import { RootState } from '../../../../redux/store';
import { MenuComponent } from '../../../../_metronic/assets/ts/components';

interface Props {
    columns: ColumnChooserModel[]
    setColumns: React.Dispatch<React.SetStateAction<ColumnChooserModel[]>>
    getColumns: () => ColumnChooserModel[]
    pageName: string
    pageVersion: string
    retryCount: number
    cancelCount: number
    retryFunction: () => void
    cancelFunction: () => void
    refreshFunction: () => void
}

const JobQueueListFilters = ({
    columns,
    setColumns,
    getColumns,
    pageName,
    pageVersion,
    retryCount,
    cancelCount,
    retryFunction,
    cancelFunction,
    refreshFunction
}: Props) => {
    const auth = useSelector((state: RootState) => state.auth)
    const canUpdate = auth.user.user?.data.authorizedMenus.find(x => x.menuName == pageName)?.canUpdate

    useEffect(() => {
        setTimeout(() => { MenuComponent.reinitialization() }, 1000)
    }, [])

    return (
        <React.Fragment>
            <TableActions
                list={[
                    { isDisabled: !canUpdate || retryCount == 0, text: `Yeniden Dene${retryCount > 0 ? ` (${retryCount})` : ''}`, onClick: retryFunction },
                    { isDisabled: !canUpdate || cancelCount == 0, text: `İptal Et${cancelCount > 0 ? ` (${cancelCount})` : ''}`, onClick: cancelFunction },
                ]}
            />

            <ColumnChooser
                columns={columns}
                getColumns={getColumns}
                pageName={pageName}
                pageVersion={pageVersion}
                setColumns={setColumns}
            />

            <div className='m-0'>
                <button type='button' onClick={refreshFunction} className='btn btn-sm fw-bold btn-light-primary'>
                    <i className='fa fa-sync-alt me-1'></i> Yenile
                </button>
            </div>
        </React.Fragment>
    )
}

export default JobQueueListFilters;
